fragment SeomaticFields on EntryInterface {
    seomatic(asArray: true) {
        metaTitleContainer
        metaTagContainer
        metaLinkContainer
    }
}
